import React from 'react';
import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Bar,
  ComposedChart
} from 'recharts';
import { UsageTrendDto } from '../../services/api';

interface UsageTrendsChartProps {
  data: UsageTrendDto[];
}

export function UsageTrendsChart({ data }: UsageTrendsChartProps) {
  // Transform data for the chart
  const chartData = data.map(item => ({
    ...item,
    date: new Date(item.date).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric' 
    })
  }));

  return (
    <div className="w-full h-80">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={chartData} margin={{ top: 5, right: 50, left: 40, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
          <XAxis
            dataKey="period"
            stroke="#64748b"
            fontSize={12}
          />
          <YAxis
            yAxisId="left"
            stroke="#64748b"
            fontSize={12}
            label={{ value: 'Uses / Likes', angle: -90, position: 'insideLeft', offset: -25, style: { fontSize: 12, fill: '#64748b' } }}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            stroke="#64748b"
            fontSize={12}
            label={{ value: 'New Prompts', angle: 90, position: 'insideRight', offset: -25, style: { fontSize: 12, fill: '#64748b' } }}
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: '#ffffff',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
            formatter={(value: any, name: string) => {
              const formatMap: { [key: string]: string } = {
                uses: 'Uses',
                likes: 'Likes', 
                submissions: 'New Prompts'
              };
              return [value.toLocaleString(), formatMap[name] || name];
            }}
            labelFormatter={(label) => `${label}`}
          />
          <Legend />
          
          {/* Bar for new submissions */}
          <Bar 
            yAxisId="right"
            dataKey="submissions" 
            fill="#3b82f6" 
            name="New Prompts"
            radius={[2, 2, 0, 0]}
            opacity={0.7}
          />
          
          {/* Lines for uses and likes */}
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="uses"
            stroke="#10b981"
            strokeWidth={3}
            dot={{ fill: '#10b981', strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6, stroke: '#10b981', strokeWidth: 2 }}
            name="Uses"
          />
          
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="likes"
            stroke="#ef4444"
            strokeWidth={3}
            dot={{ fill: '#ef4444', strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6, stroke: '#ef4444', strokeWidth: 2 }}
            name="Likes"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}